
import { Vue, Component, Prop } from "vue-property-decorator";
import S3Image from "@/components/common/s3-image.vue";
import { hslColorFromName } from "@/utils/hslColorFromName";

@Component({
    components: {
        S3Image,
    }
})
export default class ResourceAvatarNew extends Vue {
    @Prop({ type: String, default: undefined }) readonly image?: string;
    @Prop({ type: String, default: undefined }) readonly initial?: string;
    @Prop({ type: String, default: undefined }) readonly title?: string;
    @Prop({ type: String, default: undefined }) readonly subtitle?: string;
    @Prop({ type: Boolean, default: false }) readonly clickable!: boolean;
    @Prop({ type: Boolean, default: false }) readonly avatarOnly!: boolean;
    @Prop({ type: Boolean, default: false }) readonly available!: boolean;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

    get borderColor(): string {
        return this.available ? "border-green-500" : "border-gray-300";
    }
    get availableStatus(): string {
        return this.available ? "availableTrue" : "availableFalse";
    }

    get avatarContainerColor(): string {
        return this.disabled ? 'bg-gray-200' : 'bg-white';
    }

    get customAvatarStyle(): { [key: string]: boolean } {
        return {
            ["bg-gray-200 text-gray-200"]: this.disabled,
            ["text-white"]: !this.disabled,
            ["border-green-500"]: this.available,
            ["border-gray-300"]: !this.available,
        }
    }

    get bgStyle() {
        return {
            background: hslColorFromName(this.initial || ""),
        };
    }

    get ckickableClass(): string | undefined {
        if (!this.clickable) {
            return undefined;
        }
        return "cursor-pointer";
    }
}
